export default __webpack_public_path__ + "static/media/trans_fats_free.7dfea2c9.jpeg";